/**
 * Wraps ReactMarkdown to standardize our renderer needs.
 *
 * @providesModule Markdown
 * 
 */

import React from 'react'
import ReactMarkdown from 'react-markdown'

export const LinkWithTargetBlank = ({ children, ...rest }) => (
  <a {...rest} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
)

const Markdown = ({ source }) => (
  <ReactMarkdown source={source} renderers={{ link: LinkWithTargetBlank }} />
)

export default Markdown
